import React from "react"
import styled from "styled-components"

import Tag from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { ContainerLarge } from "~/components/layouts/Container"
import { RecruitmentStatus, RecruitmentType } from "~/consts"
import { Color, LineHeight, SpacingSize, TextSize } from "~/consts/style-mixins"
import ActionBar from "~/observers/ActionBar"

interface Props {
  job: string
  title: string
  companyName: string
  className?: string
  id: number
  type: keyof typeof RecruitmentType
  status: keyof typeof RecruitmentStatus
  applicationUrl?: string
  curated?: boolean
}

const ActionBarWithOverview = ({
  job,
  title,
  companyName,
  className,
  type,
  id,
  status,
  applicationUrl,
  curated,
}: Props) => {
  return (
    <Wrapper className={className}>
      <Container>
        <div className="inner">
          <Tag size="Medium" color={Color.Primary} className="tag">
            {job}
          </Tag>
          <div className="text">
            <p className="title">{title}</p>
            <Typography type="SubLabel" lineHeightProp={LineHeight.S} className="company-name">
              {companyName}
            </Typography>
          </div>
          <div className="action-bar-wrapper">
            <ActionBar type={type} id={id} status={status} applicationUrl={applicationUrl} curated={curated} />
          </div>
        </div>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  border-top: solid 1px ${Color.BorderGray};
  background: ${Color.White};
`
const Container = styled(ContainerLarge)`
  .inner {
    display: flex;
    align-items: flex-start;
    padding: ${SpacingSize.M}px 0;
  }
  .tag {
    display: block;
    margin-top: ${SpacingSize["4XS"]}px;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text {
    margin-left: ${SpacingSize.XS}px;
    max-width: calc(100% - 480px);
  }
  .title {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .company-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .action-bar-wrapper {
    margin: 0 0 0 auto;
    width: 320px;
  }
`

export default ActionBarWithOverview
